import { gateway } from "../../../gateway";


export const patchQuote = async (quoteId: number, data: any) => {
    const response = await gateway.patch(`/quotes/self/${quoteId}`, data);
    return response.data;
}